import I18n from 'i18n-js';
import React from 'react';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { buttonClassName, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import ArrowRightIcon from '@reverbdotcom/cadence/icons/core/arrow-right.svg?component';
import { MParticleEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';

interface IProps {
  listingId: string;
  cspLink?: string;
  hideArrowIcon?: boolean;
  clickEvent?: MParticleEvent;
}

export function SimilarListingsCTA(props: IProps) {
  const link = props.cspLink || `/similar/${props.listingId}`;

  return (
    <CoreLink
      to={link}
      clickEvent={props.clickEvent}
      className={buttonClassName({ variant: 'primary', fullWidth: true })}
    >
      {props.hideArrowIcon ?
        (
          I18n.t('discovery.item2EndedListingSearchButton.similarListingsCta')
        ) : (
          <RCTextWithIcon placement="right" svgComponent={ArrowRightIcon}>
            {I18n.t('discovery.item2EndedListingSearchButton.similarListingsCta')}
          </RCTextWithIcon>
        )}

    </CoreLink>
  );
}
